// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__3Csv1","left":"InfoRow_left__3rpZl"};